import styled, { css } from 'styled-components';

interface ContainerProps {
  length: number;
}

export const Container = styled.div<ContainerProps>`
  position: absolute;
  right: -180px;
  display: none;
  top: 0;
  padding: 30px;
  overflow: hidden;
  ${props =>
    props.length > 0 &&
    css`
      right: 0px;
      display: block;
    `}
`;
